<template>
    <div class="ai-instructions-block rounded-lg p-3">
        <div
            class="justify-between"
            :class="{'flex items-center' : !updateMode}"
        >
            <div>
                <div class="gap-1.5">
                    <div class="flex items-center gap-1 mb-0.5">
                        <RedesignBaseIcon
                            v-show="!isConfigured"
                            name="AlertTriangle"
                            class="w-4 h-4 text-warning shrink-0"
                        />
                        <span class="font-semibold truncate">
                            {{ $t('widget.aiInstructions.title') }}
                        </span>
                    </div>
                    <div
                        class="w-max text-sm font-medium px-1.5 py-0.5 mb-0.5 rounded-full"
                        :class="isConfigured
                            ? 'bg-green-100 text-green-700'
                            : 'bg-orange-100 text-orange-700'"
                    >
                        {{ isConfigured
                            ? $t('widget.aiInstructions.configured')
                            : $t('widget.aiInstructions.notConfigured')
                        }}
                    </div>
                </div>

                <p class="text-xs text-gray-500 mt-1.5 mb-2.5">
                    {{ $t('widget.aiInstructions.description') }}
                </p>
            </div>

            <div>
                <RedesignBaseButton
                    size="small"
                    type="outline"
                    icon="Edit"
                    @click="$emit('configure')"
                >
                    {{ $t('widget.aiInstructions.configure') }}
                </RedesignBaseButton>
            </div>
        </div>

        <RedesignFormError
            v-if="errorMessage"
            :error-message="errorMessage"
            class="mt-2"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import RedesignFormError from '@/components/RedesignBaseComponents/Form/RedesignFormError.vue'
import { WidgetConfig } from '@/types/dashboard'

const props = withDefaults(defineProps<{
    config: WidgetConfig
    errorMessage?: string
    updateMode?: boolean
}>(), {
    errorMessage: '',
    updateMode: false
})

defineEmits<{
    (e: 'configure'): void
}>()

const isConfigured = computed(() => {
    const json = props.config?.WidgetParameterValueJson
    return !!(json?.system || json?.user)
})
</script>

<style scoped>
.ai-instructions-block {
    background-color: color-mix(in srgb, var(--primary-color) 5%, transparent);
    border: 2px solid color-mix(in srgb, var(--primary-color) 20%, transparent);
}
</style>
